import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import RespondentFlowApi from "../services/respondentFlow.api";
import LoggerService from "../services/logger.service";
import { SCREENER_ROUTE, ERROR_ROUTE } from "../constants/routes.constants";
import FinSurveyPng from "../assests/magnifying-glass-icon.gif";
import {
  SURVEY_SCREENER_FAILED_SUPPLIER_REDIRECT,
  SURVEY_SCREENER_NOT_REQUIRED,
  SURVEY_SCREENER_PASSED,
  SURVEY_SCREENING,
  SURVEY_SCREENING_FAILED_RESET_QUES,
  SURVEY_SCREENER_PASSED_CLIENT_REDIRECT,
} from "../constants/event.constants";
import { Backdrop, CircularProgress, TextField } from "@mui/material";
import { BounceLoader } from "react-spinners";
import CommonFormLayout from "../components/CommonFormLayout";
import TextInputComponent from "../components/TextFieldInput";
import CheckboxInputComponent from "../components/CheckboxInput";
import RadioInputComponent from "../components/RadioInput";
import LoaderComponent from "../components/LoaderComponent";
import FormSkeleton from "../components/question-components/form-skeleton";
import FormWrapper from "../components/question-components/form-wrapper";
import SingleSelectQuestion from "../components/question-components/single-select";
import TextFieldQuestion from "../components/question-components/text-field";
import MultiSelectQuestion from "../components/question-components/multi-select";
import ButtonV2 from "../components/question-components/button";

const Start = () => {
  const [Loader, setLoader] = useState(true);
  const [ErrorMessage] = useState("");
  const [idx, setIdx] = useState(0);
  const [obj, setObj] = useState({});
  const [match, setMatch] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [errorIndex, setErrorIndex] = useState("");
  const [questions, setQuestions] = useState([]);
  // const [sessionParams, setSessionParams] = useState(null);
  const [surveyId, setSurveyId] = useState(undefined);

  let navigate = useNavigate();

 const verisolAccount = async (userId,surveyId) => {
    await window.Verisoul?.account({
      id: `${userId}-${surveyId}`,
      group: surveyId.toString() ?? "",
    });
  };

  let getVerisolSession = async (userId,surveyId) => {
    try {
      await verisolAccount(userId,surveyId);
      const { session_id } = await window.Verisoul.session();
      return session_id;
    } catch (e) {
      console.log(e);
      return null;
    }
  };

  let getDynamicProfiling = async () => {
    setLoader(true);
    let storedParam = JSON.parse(sessionStorage.getItem("params"));
    try {
      let reqObj = {};
      reqObj.token = storedParam.token;
      reqObj.userId = storedParam.userId;

      //get security config
      
      let securityConfig = await RespondentFlowApi.post("/v1/landing/security/config", {token:reqObj.token});
  
      
      if(securityConfig?.verisoulEnabled) {
        let vSession = await getVerisolSession(securityConfig.userId,securityConfig.surveyId);
        reqObj.verisolSessionId = vSession;
      }


      // reqObj.verisolSessionId = await getVerisolSession(reqObj.userId);
      reqObj.paramList = storedParam.paramList;
      reqObj.newToken = storedParam.isEnding ? storedParam.isEnding : false;
      if (reqObj.newToken) {
        reqObj.allSurveys = false;
      } else {
        reqObj.allSurveys = true;
      }

      LoggerService.log(
        storedParam.token ?? "",
        storedParam.vendorToken ?? "",
        "Sending Router Request",
        JSON.stringify(reqObj),
        storedParam.campaignUid
      );

      let resp = await RespondentFlowApi.post("/v1/profiling/dynamic", reqObj);
      LoggerService.log(
        storedParam.token ?? "",
        storedParam.vendorToken ?? "",
        "Router Response received",
        JSON.stringify(resp),
        storedParam.campaignUid
      );
      // if (resp.isInternalRedirect) {
      let obj = {};
      obj.eventType = resp.eventType;
      obj.token = resp.token;
      obj.userId = resp.userId;
      obj.questionList = resp.questionList;
      //TODO:: get campaignUid from params

      if (obj.eventType == SURVEY_SCREENING) {
        LoggerService.log(
          resp.token,
          storedParam.vendorToken ?? "",
          "Router survey received(" + resp.surveyId + "), Dynamic Profiling started(partial_match)",
          JSON.stringify(resp),
          storedParam.campaignUid ?? ""
        );
        let questionText = resp.questionList.length > 0 ? resp.questionList[0].text : "";

        LoggerService.log(
          resp.token,
          storedParam.vendorToken ?? "",
          "Dynamic Profiling(" + resp.surveyId + ") Displaying the 1st question " + questionText,
          JSON.stringify(resp),
          storedParam.campaignUid ?? ""
        );
        setQuestions(resp.questionList);
        setSurveyId(resp.surveyId);
        setLoader(false);
      } else if (obj.eventType == SURVEY_SCREENER_PASSED_CLIENT_REDIRECT) {
        await LoggerService.log(
          resp.token,
          storedParam.vendorToken ?? "",
          "Router response received, Redirecting to client(exact_match)",
          `${resp.redirectUrl}`,
          storedParam.campaignUid ?? ""
        );

        sessionStorage.removeItem("params");
        window.location.href = `${resp.redirectUrl}`;
        setLoader(true);
      } else if (obj.eventType == SURVEY_SCREENER_FAILED_SUPPLIER_REDIRECT) {
        setLoader(true);
        await LoggerService.log(
          resp.token,
          storedParam.vendorToken ?? "",
          "Router response received, Redirecting to supplier(no_match)",
          `${resp.redirectUrl}`,
          storedParam.campaignUid ?? ""
        );
        sessionStorage.removeItem("params");
        window.location.href = `${resp.redirectUrl}`;
      }
    } catch (e) {
      console.log(e);
      sessionStorage.removeItem("params");
      LoggerService.log(
        storedParam.token ?? "",
        "",
        "Router response received, redirecting to erro(error)" + e.message
      );
      navigate(ERROR_ROUTE);
    }
  };

  useEffect(() => {
    getDynamicProfiling();
  }, []);

  let saveRsponse = async (event) => {
    event.preventDefault();
    setMatch(false);
    let params = sessionStorage.getItem("params");
    let paramObj = JSON.parse(params);
    if (errorIndex === "") {
      setIsLoading(true);
      let reqObj = {};
      reqObj.userId = paramObj.userId;
      reqObj.token = paramObj.token;
      reqObj.surveyId = surveyId;
      reqObj.newToken = paramObj.isEnding ? paramObj.isEnding : false;
      reqObj.responses = [
        {
          id: obj.id,
          answerText: obj.answerText,
          answerId: obj.answerId,
        },
      ];
      if (questions.length - 1 === idx) {
        reqObj.isLastQuestion = true;
      } else {
        reqObj.isLastQuestion = false;
      }
      let dbquestionText = obj.text ?? "";
      LoggerService.log(
        paramObj.token ?? "",
        paramObj.vendorToken ?? "",
        `Saving ${idx + 1}  dynamic profiling question - ${dbquestionText}`,
        JSON.stringify(reqObj),
        paramObj.campaignUid ?? ""
      );

      try {
        let response = await RespondentFlowApi.post(`/v1/profiling/d/response`, reqObj);

        if (response.status === false) {
          LoggerService.log(
            response.token,
            paramObj.vendorToken ?? "",
            "Qualification terminated",
            JSON.stringify(response),
            paramObj.campaignUid ?? ""
          );
          if (response.eventType === SURVEY_SCREENING) {
            LoggerService.log(
              response.token,
              paramObj.vendorToken ?? "",
              "New Router survey " + response.surveyId + " received, Dynamic Profiling started(partial_match)",
              JSON.stringify(response),
              paramObj.campaignUid ?? ""
            );

            let questionText = response.questionList.length > 0 ? response.questionList[0].text : "";
            //
            LoggerService.log(
              response.token,
              paramObj.vendorToken ?? "",
              "Dynamic Profiling(" + response.surveyId + ") Displaying the 1st question" + questionText,
              JSON.stringify(response),
              paramObj.campaignUid ?? ""
            );
            setQuestions(response.questionList);
            setSurveyId(response.surveyId);
            setIdx(0);
            setErrorIndex("");
            setMatch(true);
            setIsLoading(false);
          } else if (response.eventType === SURVEY_SCREENER_FAILED_SUPPLIER_REDIRECT) {
            setIsLoading(true);
            LoggerService.log(
              response.token,
              paramObj.vendorToken ?? "",
              "Dynamic Profiling(no_survey), Redirecting to supplier(no_match)",
              `${response.redirectUrl}`,
              paramObj.campaignUid ?? ""
            );
            sessionStorage.removeItem("params");
            window.location.href = `${response.redirectUrl}`;
          }
        } else {
          if (response.eventType === SURVEY_SCREENING) {
            // is Last question

            if (questions.length - 1 === idx) {
            } else {
              let questionText = questions[idx + 1]?.text ?? "";
              LoggerService.log(
                response.token,
                paramObj.vendorToken ?? "",
                `Dynamic Profiling(${reqObj.surveyId}) Displaying the ${idx + 1} question - ${questionText}`,
                JSON.stringify(response),
                paramObj.campaignUid ?? ""
              );
              setErrorIndex("");
              setIdx(idx + 1);
              setMatch(true);
              setIsLoading(false);
            }
          } else if (response.eventType === SURVEY_SCREENER_PASSED_CLIENT_REDIRECT) {
            LoggerService.log(
              response.token,
              paramObj.vendorToken ?? "",
              "Dynamic Profiling (" + response.surveyId + ") Completed, redirecting to client(partial_match)",
              `${response.redirectUrl}`,
              paramObj.campaignUid ?? ""
            );
            window.location.href = `${response.redirectUrl}`;
          }
        }
      } catch (e) {
        console.error(e);
        LoggerService.log(
          paramObj.token ?? "",
          paramObj.vendorToken ?? "",
          "error in saving response " + JSON.stringify(e),
          "",
          paramObj.campaignUid ?? ""
        );
        setIsLoading(false);
        navigate(ERROR_ROUTE);
      }
    }
  };

  useEffect(() => {
    if (questions.length > 0 && questions[idx]) {
      setObj(JSON.parse(JSON.stringify(questions[idx])));
    }
    // eslint-disable-next-line
  }, [questions, idx]);

  useEffect(() => {
    if (obj.type === 3 || obj.type === 4) {
      if (
        !obj?.answerText ||
        obj?.answerText === null ||
        obj?.answerText === "" ||
        (obj.id === 59 && obj?.answerText > 99) ||
        (obj.id === 59 && obj?.answerText < 18)
      ) {
        setErrorIndex(obj.id);
      } else {
        setErrorIndex("");
      }
    } else {
      if (!obj?.answerId || obj?.answerId?.length === 0) {
        setErrorIndex(obj.id);
      } else {
        setErrorIndex("");
      }
    }

    // eslint-disable-next-line
  }, [obj]);

  const responsequestions = (e) => {
    e.preventDefault();
  };

  return (
    <div>
      {Loader || isLoading ? (
        <FormSkeleton />
      ) : (
        // <form
        // onSubmit={Loader || isLoading ? responsequestions : saveRsponse}
        // noValidate
        //   className="max-w-3xl mx-auto w-full h-[100dvh] py-2 relative"
        // >
        //   <CommonFormLayout
        //     key={questions[idx]?.id || idx}
        //     header={<h2 className="text-base font-semibold">{questions[idx]?.text}</h2>}
        //     description={
        //       !match && errorIndex === questions[idx]?.id ? (
        //         <span className="text-xs text-red-500">This field is required!</span>
        //       ) : (
        //         ""
        //       )
        //     }
        //     footer={
        //       <div className="flex justify-end">
        // <button type="submit" className="button" onClick={() => setMatch(false)}>
        //   Next
        // </button>
        //       </div>
        //     }
        //   >
        //     {(questions.length > 0 && questions[idx] && questions[idx] && questions[idx].type === 4) ||
        //     (questions.length > 0 && questions[idx] && questions[idx] && questions[idx].type === 3) ? (
        //       <TextInputComponent
        //         variant="outlined"
        //         id={questions[idx]?.id}
        //         label={questions[idx]?.text}
        //         value={obj?.answerText}
        //         onChange={(e) => {
        //           let payload = { ...obj };
        //           payload.answerText = e.target.value;
        //           setObj(JSON.parse(JSON.stringify(payload)));
        //         }}
        //         error={!match && errorIndex === questions[idx]?.id ? true : false}
        //         helperText={
        //           !match && errorIndex === questions[idx]?.id && obj.answerText > 99
        //             ? "This value not be greater then 100 and"
        //             : obj.answerText < 18
        //             ? "This value not be Less then 18"
        //             : "This field is required!"
        //         }
        //       />
        //     ) : questions.length > 0 && questions[idx] && questions[idx].type === 1 ? (
        //       <div
        //         className={
        //           questions[idx]?.options.length > 12
        //             ? "grid md:grid-cols-2 gap-4 grid-cols-1 mt-2"
        //             : "grid md:grid-cols-1 gap-4 grid-cols-1 mt-2"
        //         }
        //       >
        //         {questions.length > 0 &&
        //           questions[idx].options.map((item) => (
        //             <div className="flex space-x-3 justify-start" key={item.id}>
        //               <RadioInputComponent
        //                 id={`radio_${item.id}`}
        //                 name={obj?.id}
        //                 label={item.text}
        //                 value={item.id}
        //                 checked={obj?.answerId?.includes(item.id)}
        //                 onChange={(e) => {
        //                   let payload = { ...obj };
        //                   if (e.target.checked) {
        //                     payload.answerId = [item.id];
        //                   } else {
        //                   }
        //                   setObj(JSON.parse(JSON.stringify(payload)));
        //                 }}
        //               />
        //             </div>
        //           ))}
        //       </div>
        //     ) : (
        //       <div
        //         className={
        //           questions[idx]?.options.length > 12
        //             ? "grid md:grid-cols-2 gap-4 grid-cols-1 mt-2"
        //             : "grid md:grid-cols-1 gap-4 grid-cols-1 mt-2"
        //         }
        //       >
        //         {questions.length > 0 &&
        //           questions[idx].options.map((item) => (
        //             <div className="flex space-x-3 justify-start" key={item.id}>
        //               <CheckboxInputComponent
        //                 id={`checkbox_${item.id}`}
        //                 name={obj?.id}
        //                 label={item.text}
        //                 value={item.id}
        //                 checked={obj?.answerId?.includes(item.id)}
        //                 onChange={(e) => {
        //                   let payload = { ...obj };
        //                   if (e.target.checked) {
        //                     payload.answerId = [item.id];
        //                   } else {
        //                   }
        //                   setObj(JSON.parse(JSON.stringify(payload)));
        //                 }}
        //               />
        //             </div>
        //           ))}
        //       </div>
        //     )}
        //   </CommonFormLayout>
        // </form>
        <form
          className=" w-full h-[100dvh]"
          onSubmit={Loader || isLoading ? responsequestions : saveRsponse}
          noValidate
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              const form = e.currentTarget;
              form.requestSubmit();
            }
          }}
        >
          <FormWrapper
            footer={
              // <button type="submit" className="button" onClick={() => setMatch(false)}>
              //   Next
              // </button>
              <ButtonV2 type="submit" onClick={() => setMatch(false)}>
                Next
              </ButtonV2>
            }
          >
            {questions.length > 0 &&
              questions[idx] &&
              (() => {
                const value = questions[idx];
                const hasError = !match && errorIndex === value.id;

                return (
                  <>
                    {value.type === 1 && (
                      <SingleSelectQuestion
                        question={{
                          id: value.id,
                          label: value.text,
                          options: value.options,
                          description: hasError ? "This field is required!" : null,
                          required: false,
                        }}
                        value={value.answerId?.[0]}
                        onChange={(selected) => {
                          const payload = [...questions];
                          payload[idx].answerId = [selected];
                          setQuestions(payload);
                        }}
                      />
                    )}

                    {(value.type === 3 || value.type === 4) && (
                      <TextFieldQuestion
                        question={{
                          id: value.id,
                          label: value.text,
                          required: false,
                          description: hasError ? "This field is required!" : null,
                          type: value.type,
                        }}
                        value={value.answerText ?? ""}
                        onChange={(val) => {
                          const payload = [...questions];
                          payload[idx].answerText = val;
                          setQuestions(payload);
                        }}
                        error={hasError}
                        helperText={
                          hasError
                            ? value.id === 59
                              ? Number(value.answerText) > 99
                                ? "This value cannot be greater than 100."
                                : Number(value.answerText) < 18
                                ? "This value cannot be less than 18."
                                : "This field is required!"
                              : "This field is required!"
                            : ""
                        }
                      />
                    )}

                    {value.type === 2 && (
                      <MultiSelectQuestion
                        question={{
                          id: value.id,
                          label: value.text,
                          options: value.options,
                          required: false,
                          description: hasError ? "This field is required!" : null,
                        }}
                        value={value.answerId ?? []}
                        onChange={(selectedValues) => {
                          const payload = [...questions];
                          payload[idx].answerId = selectedValues;
                          setQuestions(payload);
                        }}
                      />
                    )}
                  </>
                );
              })()}
          </FormWrapper>
        </form>
      )}
    </div>
  );
};

export default Start;
